import { TableActions } from '@core/components/Table';
import { useApiUtils } from '@core/util/apiUtils';
import { downloadFile } from '@core/util/downloadUtils';
import FaXmlFileIcon from 'app/assets/icon/FaXmlFileIcon';
import notaFiscalApi from 'app/services/api/notaFiscalApi';
import { relatorioApi } from 'app/services/api/relatorioApi';
import * as Actions from 'app/store/actions';
import { eventReactGA } from 'app/utils/analyticsUtil';
import { visualizarRelatorioV2 } from 'app/utils/enviromentUtil';
import React, { useContext } from 'react';
import { FaFileExcel, FaFilePdf } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { NotaFiscalContext } from '../NotaFiscalContext';

const NOTA_FISCAL = 'Nota fiscal';

const NotaFiscalFab = () => {
  const [search] = useContext(NotaFiscalContext).search;
  const [selecao] = useContext(NotaFiscalContext).selecao;
  const [tipoSelecao] = useContext(NotaFiscalContext).tipoSelecao;
  const [, setLoading] = useContext(NotaFiscalContext).loading;
  const [notasFiscais] = useContext(NotaFiscalContext).notasFiscais;
  const [somatorios] = useContext(NotaFiscalContext).somatorios;
  const [data] = useContext(NotaFiscalContext).data;

  const existeSelecionados = selecao.length > 0 || tipoSelecao !== 'NENHUM';

  const selecaoPossuiRegistroComPermissaoExportacao = selecao?.some(
    (s) =>
      s.situacao === 'FATURADO' ||
      s.situacao === 'EMITIDA' ||
      s.situacao === 'CANCELADO' ||
      s.situacao === 'EM_CANCELAMENTO'
  );

  const filtroPossuiRegistroComPermissaoExportacao =
    somatorios?.qtdeFaturado > 0 ||
    somatorios?.qtdeEmitido > 0 ||
    somatorios?.qtdeCancelado > 0 ||
    somatorios?.qtdeEmCancelamento > 0;

  const desabilitarExportacao =
    tipoSelecao === 'TODOS_FILTRO'
      ? !filtroPossuiRegistroComPermissaoExportacao
      : !selecaoPossuiRegistroComPermissaoExportacao;

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const handleExportarExcel = () => {
    eventReactGA(NOTA_FISCAL, 'Gerar relatório em Excel');
    notaFiscalApi
      .exportarExcel({ q: search?.q || '', mesCompetencia: search?.mesCompetencia || data })
      .then((response) => {
        const link = document.createElement('a');
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.arquivo}`;
        link.download = `${response.data.nome}.xlsx`;
        link.click();
      })
      .catch((err) => {
        apiUtils.handleApiError(err);
      });
  };

  const handleExportarPDF = async () => {
    eventReactGA(NOTA_FISCAL, 'Gerar relatório em PDF');
    const response = await relatorioApi().salvarFiltroGerarRelatorioFaturamentoPDF(
      search?.q || '',
      search?.mesCompetencia || data
    );
    visualizarRelatorioV2(response.data);

    // const params = `q=${search.q}&mesCompetencia=${search.mesCompetencia}`;
    // visualizarRelatorio('', 'nota-fiscal/exportar-pdf', '', params);
  };

  const handlerExportarNotaFiscalPDF = async () => {
    try {
      setLoading(true);

      const params = {
        ...search,
        ids: selecao.map((item) => item.id),
        tipoSelecao,
      };
      delete params.page;
      delete params.size;
      delete params.sort;

      eventReactGA(NOTA_FISCAL, 'Exportar notas fiscais em PDF');
      const response = await notaFiscalApi.exportarNotaFiscalPDF(params);
      downloadFile(response.data.bytes, `Notas fiscais PDF - ${new Date().toLocaleDateString('pt-BR')}.zip`);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const handlerExportarNotaFiscalXML = async () => {
    try {
      setLoading(true);

      const params = {
        ...search,
        ids: selecao.map((item) => item.id),
        tipoSelecao,
      };
      delete params.page;
      delete params.size;
      delete params.sort;

      eventReactGA(NOTA_FISCAL, 'Exportar notas fiscais em XML');
      const response = await notaFiscalApi.exportarNotaFiscalXML(params);
      downloadFile(response.data.bytes, `Notas fiscais XML - ${new Date().toLocaleDateString('pt-BR')}.zip`);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const actions = [
    {
      icon: <FaFileExcel />,
      name: 'exportarEXCEL',
      tooltip: 'Gerar relatório em Excel',
      show: notasFiscais.length > 0,
      onClick: handleExportarExcel,
    },
    {
      icon: <FaFilePdf />,
      name: 'exportarPDF',
      tooltip: 'Gerar relatório em PDF',
      show: notasFiscais.length > 0,
      onClick: () => handleExportarPDF(),
    },
    {
      icon: <FaFilePdf />,
      name: 'exportarNotasPdf',
      tooltip: 'Exportar notas fiscais em PDF',
      show: existeSelecionados,
      onClick: () => !desabilitarExportacao && handlerExportarNotaFiscalPDF(),
      disabled: desabilitarExportacao && 'Os registros selecionados não possuem Nota Fiscal',
    },
    {
      icon: <FaXmlFileIcon size={16} fontSize={2.5} />,
      name: 'exportarNotasXml',
      tooltip: 'Exportar notas fiscais em XML',
      show: existeSelecionados,
      onClick: () => !desabilitarExportacao && handlerExportarNotaFiscalXML(),
      disabled: desabilitarExportacao && 'Os registros selecionados não possuem Nota Fiscal',
    },
  ];

  return <TableActions className={'stepPlusButton'} actions={actions} />;
};

export default NotaFiscalFab;
